import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { setShowEditControl } from 'reducers/livingCarbonGrantReducer';
import PlantingSiteTable from './PlantingSiteTable';
import FenceTable from './FenceTable';
import SurroundingProperties from './SurroundingPropertiesTable';

const ChecklistItem = ({ condition, text }) => (
  <>
    <FontAwesomeIcon
      icon={condition ? 'check' : 'times'}
      transform="shrink-2"
      className={condition ? 'text-success me-1' : 'text-danger me-1'}
    />
    <label className={condition ? 'text-success' : 'text-danger'}>{text}</label>
  </>
);
ChecklistItem.propTypes = {
  condition: PropTypes.bool.isRequired,
  text: PropTypes.string.isRequired
};

// onDrawPlantingSite calls handleDrawPlanting (generate-grant/index.js)
const Requirements = ({ onDrawPlantingSite }) => {
  const dispatch = useDispatch();
  const { treeMarkers, plantingSites, fence } = useSelector(
    state => state.livingCarbonGrant
  );

  const handleTabSwitch = () => {
    dispatch(setShowEditControl(false)); // when switching tab in the midst of drawing polygon, abort
  };

  return (
    <>
      {/* <Button variant="primary" onClick={() => console.log('switch')}>
        Switch to summary view
      </Button> */}
      <Tabs
        defaultActiveKey="planting-sites"
        id="uncontrolled-tab-example"
        className="mb-3"
        onSelect={handleTabSwitch}
      >
        <Tab eventKey="planting-sites" title="Planting Sites" icon="map">
          <PlantingSiteTable onDrawPlantingSite={onDrawPlantingSite} />
        </Tab>
        <Tab eventKey="fence" title="Fence">
          <FenceTable onDrawPlantingSite={onDrawPlantingSite} />
        </Tab>
        <Tab eventKey="photo-monitoring-point" title="Photo Monitoring Point">
          Photo monitoring point
        </Tab>
        <Tab eventKey="surrounding-properties" title="Surrounding Properties">
          <SurroundingProperties
            onDrawSurroundingProperties={onDrawPlantingSite}
          />
        </Tab>
      </Tabs>
      <p>Estimated Carbon Offset: {treeMarkers.length * 22}kg</p>
      <p>Estimated Cost: ${treeMarkers.length * 2}</p>

      <h5>Grant must contain the following:</h5>
      <ChecklistItem
        condition={plantingSites.length > 0}
        text="At least one planting site"
      />
      <br />
      <ChecklistItem condition={fence.length > 0} text="At least one fence" />
      <br />
      {/* <ChecklistItem
        condition={photoMonitoringPoint.length > 0}
        text="At least one photo monitoring point"
      /> */}
    </>
  );
};

Requirements.propTypes = {
  onDrawPlantingSite: PropTypes.func
};

export default Requirements;
